// node-modules
import ScrollMagic from 'scrollmagic';
import _debounce from 'lodash/debounce';

// other
import { selectors } from '@/scripts/animation';
import { Lerper } from '@/scripts/utils';
import { controller } from '@/components/_scrollmagic';

// assets
import './parallax-img.scss';

const getContainerHeight = $container =>
  $container.height() || $container.width() * 0.5625; // responsive image

export default function parallaxImage(mainContainer = document) {
  const scenes = [];
  const namespace = 'parallax-image';
  const { parallaxDistance, parallaxImageContainer, parallaxItem } = selectors;

  mainContainer.querySelectorAll(parallaxImageContainer)
    .forEach((container) => {
      const { curtains } = container.dataset;

      const $container = $(container);
      const $img = $container.find(parallaxItem);
      const lerpers = [];
      let containerHeight = getContainerHeight($container);

      $container.addClass(namespace);
      $img.addClass(`${namespace}__item`);

      const translateLerper = new Lerper({
        onTick(value) {
          $img.css('transform', `translateY(${value * parallaxDistance}px)`);
        },
      });
      lerpers.push(translateLerper);


      if (curtains) {
        const sides = [$(`<span class="${namespace}__left-side"></span>`), $(`<span class="${namespace}__right-side"></span>`)];
        $container.append(sides);
        const curtainsLerper = new Lerper({
          onTick(value) {
            sides.forEach(($side) => {
              $side.css('transform', `scaleX(${value})`);
            });
          },
        });
        lerpers.push(curtainsLerper);
      }


      const scene = new ScrollMagic.Scene({
        triggerElement: container,
        triggerHook: 'onEnter',
        offset: -80,
        duration: containerHeight + $(window).height(),
      })
        .on('progress', (e) => {
          lerpers.forEach(lerper => lerper.setValue(e.progress));
        })
        // .addIndicators({name: 'parallax-image'})
        .addTo(controller);

      const resize = () => {
        containerHeight = getContainerHeight($container);
        $img.css({
          height: containerHeight + parallaxDistance,
        });
        scene.duration(containerHeight + $(window).height());
      };

      const debouncedResize = _debounce(resize, 100);

      resize();

      window.addEventListener('resize', debouncedResize);

      scenes.push({
        destroy() {
          scene.destroy();
          lerpers.forEach((lerper) => {
            lerper.destroy();
          });
          window.removeEventListener('resize', debouncedResize);
        },
      });
    });
  return scenes;
}



// WEBPACK FOOTER //
// ./components/_scrollmagic/scenes/parallax-image/parallax-image.js